/* ------------------------- */
/*        HOME SOCIAL        */
/* ------------------------- */
HomeSocial = {
    mediaQuery: window.matchMedia("(max-width: 768px)"),
    reducedMotionQuery: window.matchMedia("(prefers-reduced-motion: reduce)"),
    zoomItems: [],
    zoomFrame: null,

    init: function () {
        $(".swiper--home-social").each(function () {
            const slider = this;

            if (HomeSocial.mediaQuery.matches) {
                if (slider.swiper) {
                    slider.swiper.update();
                    return;
                }

                new Swiper(slider, {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                    pagination: {
                        el: $(slider).siblings(".home-social__pagination")[0],
                        clickable: true
                    }
                });
            } else if (slider.swiper) {
                const animationStyles = ["opacity", "transform", "visibility"].map(function (property) {
                    return {
                        property: property,
                        value: slider.style.getPropertyValue(property),
                        priority: slider.style.getPropertyPriority(property)
                    };
                });

                slider.swiper.destroy(true, true);

                animationStyles.forEach(function (style) {
                    if (style.value) {
                        slider.style.setProperty(style.property, style.value, style.priority);
                    }
                });

                const wrapper = slider.querySelector(".swiper-wrapper");
                if (wrapper) wrapper.removeAttribute("style");

                slider.querySelectorAll(".swiper-slide").forEach(function (slide) {
                    slide.removeAttribute("style");
                });
            }
        });

        HomeSocial.initImageZoom();
    },

    initImageZoom: function () {
        HomeSocial.zoomItems = Array.from(document.querySelectorAll(".swiper--home-social[data-imgzoom] .home-social-card__media"));

        if (HomeSocial.zoomItems.length) HomeSocial.bindImageZoom();

        if (!HomeSocial.zoomItems.length || HomeSocial.reducedMotionQuery.matches) {
            HomeSocial.zoomItems.forEach(function (media) {
                media.style.setProperty("--home-social-image-scale", "1");
            });
            return;
        }

        HomeSocial.updateImageZoom();
    },

    updateImageZoom: function () {
        HomeSocial.zoomFrame = null;

        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        HomeSocial.zoomItems.forEach(function (media) {
            const rect = media.getBoundingClientRect();
            const animationDistance = viewportHeight + rect.height * 0.5;
            const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / animationDistance));
            const scale = 1.2 - progress * 0.2;

            media.style.setProperty("--home-social-image-scale", scale.toFixed(4));
        });
    },

    requestImageZoomUpdate: function () {
        if (HomeSocial.zoomFrame || HomeSocial.reducedMotionQuery.matches) return;

        HomeSocial.zoomFrame = window.requestAnimationFrame(HomeSocial.updateImageZoom);
    },

    bindImageZoom: function () {
        if (HomeSocial.imageZoomBound) return;

        window.addEventListener("scroll", HomeSocial.requestImageZoomUpdate, { passive: true });
        window.addEventListener("resize", HomeSocial.requestImageZoomUpdate);

        if (HomeSocial.reducedMotionQuery.addEventListener) {
            HomeSocial.reducedMotionQuery.addEventListener("change", HomeSocial.initImageZoom);
        } else {
            HomeSocial.reducedMotionQuery.addListener(HomeSocial.initImageZoom);
        }

        HomeSocial.imageZoomBound = true;
    },

    bindBreakpoint: function () {
        if (HomeSocial.breakpointBound) return;

        if (HomeSocial.mediaQuery.addEventListener) {
            HomeSocial.mediaQuery.addEventListener("change", HomeSocial.init);
        } else {
            HomeSocial.mediaQuery.addListener(HomeSocial.init);
        }

        HomeSocial.breakpointBound = true;
    }
};

$(document).ready(function () {
    HomeSocial.init();
    HomeSocial.bindBreakpoint();
});

$(document).on("shopify:section:load", function () {
    HomeSocial.init();
});
